module.exports = __webpack_public_path__ + "resources/img/img_coolfilter4.35e5e70dc64ac38a11cf12dfdb937fc6.png";